import * as S from '@effect/schema/Schema';

export const PaginatedBody = S.Struct({
    particlesForProducts: S.Record({ key: S.String, value: S.Unknown }),
    next: S.optional(S.String),
});

export type PaginatedBody = S.Schema.Type<typeof PaginatedBody>;

const Particles = S.Struct({
    particlesForProducts: S.Record({ key: S.String, value: S.Array(S.String) }), // Record<ProductId, ParticleId[]>
});

export type Particles = S.Schema.Type<typeof Particles>;

export const decodeParticles = S.decodeUnknownSync(Particles);
